export const ROUTE_PATHS = {
  home: '/',

  market: '/market',

  history: {
    request: '/history/request',
    investment: '/history/investment',
    trade: '/history/trade-history',
    margin: '/history/margin',
    spot: '/history/spot',
    referral: '/history/referral',
    transfer: '/history/transfer'
  },

  referral: '/referral',

  wallet: {
    spot: '/wallet/spot',
    margin: '/wallet/margin',
    marginSingle: (id) => `/wallet/margin/${id || ":id"}`,
    investment: '/wallet/investment-fund',
  },

  trade: {
    basic: (source, destination) => `/trade/${source || ":source"}/${destination || ":destination"}`,
    advanced: (source, destination) => `/advanced-trade/${source || ":source"}/${destination || ":destination"}`,
  },

  withdraw: (coin) => `/withdraw/${coin}`,
  deposit: (coin) => `/deposit/${coin}`,

  convert: '/convert',

  portfolio: '/portfolio',
  portfolioSingle: (type, id) => `/portfolio-details/${type}/${id}`,


  bank_accounts: '/bank-accounts',

  rules: (id) => `/rules/${id || ":id"}`,

  notifications: '/notifications',

  activities: '/activities',

  p2p: "/p2p",

  not_permitted: "/not_permitted",
}